<template>
  <header class="page-header blog-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12">
          <div
            class="blog-article-header"
            :class="{ 'blog-article-header--with-image': image }"
          >
            <div class="blog-article-header__info">
              <div v-if="categories.length" class="blog-article-header__categories">
                <template v-for="category in categories" :key="category.name">
                  <div class="blog__category" :class="category.class">
                    {{ category.name }}
                  </div>
                </template>
              </div>
              <h1 class="blog-article-header__title">{{ title }}</h1>
              <p v-if="description" class="blog-article-header__description">
                {{ description }}
              </p>
              <p v-if="publishedLabel" class="blog-article-header__meta">
                {{ publishedLabel }}
              </p>
            </div>
            <div v-if="image" class="blog-article-header__media">
              <img
                class="blog__hero-image"
                :src="image"
                :alt="title"
                width="900"
                height="557"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "BlogArticleHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    publishedAt: {
      type: String,
      default: "",
    },
  },
  computed: {
    categories() {
      if (!this.category) {
        return [];
      }

      return this.category.split(",").map((cat) => {
        const name = cat.trim();
        return {
          name,
          class: "blog__category--" + name.toLowerCase().replace(/\s+/g, "-"),
        };
      });
    },
    publishedLabel() {
      if (!this.publishedAt) {
        return "";
      }

      const date = new Date(this.publishedAt);
      if (Number.isNaN(date.getTime())) {
        return "";
      }

      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
  },
};
</script>
